export const SMS_TIMEOUT = {
  long: 240,
  short: 5,
}

export const SMS_CODE_LENGTH = 6
